module.exports = __webpack_public_path__ + "static/media/Payment-b.56871729.jpg";